import {
  InvoicePaymentType,
  Language,
  InvoicePaymentPeriod,
  InvoiceStatus,
  NotificationStatus,
  WalletOrderType,
  ActivityTemplateStatus
} from '@link/admin/services/const';

export default {
  common: {
    edit: '편집',
    search: '검색',
    keyword: '키워드',
    action: '작업',
    status: '상태',
    clickToUpload: '업로드',
    uploading: '업로드 중',
    copy: '복사',
    delete: '삭제',
    continueConfirm: '계속 진행하시겠습니까?',
    confirmDelete: '{{name}}을 삭제하시겠습니까?',
    account: '계정',
    signOut: '로그아웃'
  },
  layouts: {
    sidebar: {
      contracts: '계약 관리',
      suppliers: '공급사 관리',
      agents: 'OTA 관리',
      finance: '결제 관리',
      notifications: '알림 관리',
      dataExport: '데이터 출력',
      activities: '판매 상품 목록',
      tools: '도구 목록',
      opsFreeze: 'OPS 동결'
    }
  },
  views: {
    opsFreeze: {
      separatorHint:
        '줄바꿈, 공백, 쉼표(, ，) 또는 「、」로 구분하여 입력할 수 있습니다',
      register: '등록',
      bookingIdsInput: '예약 번호 입력',
      maxBookingCount: '최대 {{max}}건',
      exceedMaxCount: '최대 건수를 초과했습니다',
      createSuccess: '등록되었습니다',
      freezeOperation: '동결 작업',
      unfreezeOperation: '동결 해제 작업',
      reason: '비고',
      reasonPlaceholder: '작업 사유를 입력하세요 ({{max}}자 이내)',
      submitFreeze: '동결',
      submitUnfreeze: '동결 해제',
      freezing: '동결 중',
      unfreezing: '해제 중',
      processingHint: '처리가 완료되면 CSV가 자동으로 다운로드됩니다',
      freezeSuccess: '동결이 완료되었습니다',
      unfreezeSuccess: '동결 해제가 완료되었습니다',
      titleWithCount: '동결 기록 목록・{{count}}건',
      newFreeze: '신규 동결',
      batchNo: '번호',
      createdAt: '작성 일시',
      status: '상태',
      targetBookings: '대상 예약',
      lastOperation: '최종 작업',
      bookingCount: '{{count}}건',
      statusLabel: {
        frozen: '동결됨',
        unfrozen: '해제됨',
        notOperated: '미작업'
      },
      action: {
        freeze: '동결',
        unfreeze: '동결 해제'
      }
    },
    activities: {
      pageTitle: '판매 상품 목록',
      searchTitle: '상품 검색',
      activityId: '상품 ID',
      templateId: 'Template ID',
      activityUrl: '상품 URL',
      title: '상품명',
      supplier: '공급사',
      supplierId: '공급사 ID',
      supplierName: '공급사명',
      salesStatus: '상품 표시',
      listDisplay: '상품 목록 표시',
      category: '카테고리',
      country: '상품 국가・지역',
      confirmationType: '재고 유형',
      inSalePeriod: '판매 기간 내',
      unspecified: '지정 안 함',
      salePeriod: '판매 기간',
      netPrice: '도매가(NET)',
      grossPrice: '판매가(GROSS)',
      unlimited: '무기한',
      downloadCsv: 'CSV 다운로드',
      snapshotHint:
        '표시된 데이터는 전일 기준입니다(매일 심야 업데이트). 최종 업데이트: {{time}}',
      templateStatus: {
        [ActivityTemplateStatus.ActivityTemplateStatusPublished]: '공개됨',
        [ActivityTemplateStatus.ActivityTemplateStatusReviewing]:
          '공개 신청 중',
        [ActivityTemplateStatus.ActivityTemplateStatusApproved]: '공개 확인됨',
        [ActivityTemplateStatus.ActivityTemplateStatusDraft]: '초안'
      }
    },
    dataExport: {
      period: '기간',
      dataExport: '데이터 출력',
      bookingData: '예약 데이터',
      download: '파일 다운로드',
      monthLabel: '{{year}}년 {{month}}월',
      downloadHint:
        '버튼을 누른 후 자동 다운로드가 시작될 때까지 화면을 닫지 마세요.',
      currentMonthHint:
        '당월 데이터는 준비가 완료되는 대로 Slack 채널로 전송됩니다. 잠시만 기다려 주세요.',
      slackNotice: '데이터 준비가 완료되는 대로 Slack 채널로 전송됩니다',
      notGenerated: '선택한 기간의 데이터가 아직 생성되지 않았습니다'
    },
    dashboard: {
      title: '대시보드'
    },
    whitelist: {
      title: '화이트리스트',
      add: '화이트리스트에 추가',
      alertTitle: 'OTA 추가'
    },
    activityPublish: {
      title: '상품 공개 관리',
      alertTitle: '상품 공개 확인'
    },
    suppliersList: {
      title: '공급사 목록',
      supplierCustomId: '공급사(ID)',
      originalName: '공급사명',
      englishName: '공급사(영문명)',
      country: '국가·지역',
      action: '작업'
    },
    agentsList: {
      title: 'OTA 목록',
      originalName: 'OTA명',
      englishName: 'OTA명(EN)',
      paymentType: '결제 방법',
      country: '국가·지역'
    },
    orgList: {
      title: '그룹 관리',
      searchLabel: 'OTA'
    },
    agentAccountList: {
      title: '계정 관리',
      otaLabel: 'OTA',
      otaOrgLabel: '소속 그룹'
    },
    apiKeyList: {
      title: 'api-key',
      otaId: 'OTA',
      otaOrgId: '조직',
      createTime: '생성일',
      addConfirmTitle: 'API 키 추가 확인',
      deleteConfirmTitle: 'API 키 삭제 확인'
    },
    agentsCharge: {
      title: '잔액 관리'
    },
    financeTransactions: {
      title: '정산서',
      transactionStatus: '정산 현황',
      keyword: 'ID 검색',
      difference: '거래 유형',
      differenceOTA: 'OTA',
      differenceSupplier: '공급사',
      dueDate: '청구서 발행일',
      invoiceNumber: '청구 ID',
      date: '청구 시기',
      fromDate: '{{fromDate}}~{{toDate}}',
      currency: '통화 단위',
      amount: '결제 금액 합계',
      preAmount: '조정 전 청구 금액',
      lastAmount: '최종 합계 금액',
      adjustedAmount: '조정 금액',
      finalAmount: '최종 합계 금액',
      adjust: '조정',
      showjust: '표시',
      paid: '입금 완료',
      change: '결제 완료',
      invoice: '청구 내역',
      jaInvoice: '지불 통지서(일본어)',
      jaInvoiceDetails: '명세서(일본어)',
      enInvoice: '지불 통지서(영문)',
      enInvoiceDetails: '명세서(영문)',
      attachment: '첨부 파일',
      changeTitle: '결제 완료되었습니까?',
      changeTitlePay: '입금 완료되었습니까?',
      changeMessage: '거래 상태는 “결제 완료”로 변경됩니다',
      changeMessagePay: '거래 상태는 “입금 완료”로 변경됩니다',
      depositTitle: '거래 정보',
      depositDate: '입금일',
      depositAmount: '입금 금액',
      payDate: '지급일',
      payAmount: '출금 금액',
      remark: '비고',
      confirmButton: '입금 완료',
      invoiceList: '청구서 목록',
      payNoticeList: '지불 통지서 목록'
    },
    financeCharge: {
      title: '잔액 관리',
      agentId: 'OTA ID',
      agentName: 'OTA명',
      country: '국가/지역',
      method: '결제 환불 금액',
      chargeCycle: '결제 주기',
      status: '확인 대기 / 청구 이력',
      includeDeletedAgents: '삭제된 OTA를 포함',
      bulkDownload: '일괄 다운로드',
      downloadTitle: '잔액 기록 다운로드',
      downloadMessage: '시작 시간과 종료 시간을 선택해 주세요',
      startTime: '시작 시간',
      endTime: '종료 시간'
    },
    financeChargeHistory: {
      title: '충전 이력',
      date: '일시',
      amount: '금액',
      invoice: '선불 청구서',
      status: '정산 상태',
      note: '비고',
      code: '확인 코드',
      change: '작업',
      invoiceStatusConfirmed: '입금 완료',
      changeTitle: '입금을 확인했습니다',
      changeConfirm: '해당 계정에 충전을 진행하시겠습니까?',
      accountBalance: '계정 잔액',
      accountBuffer: '계정 버퍼',
      deposit: '입금',
      changeAmount: '금액 변경',
      walletTitle: '계정 정보',
      amountType: '입금 유형'
    },
    webHook: {
      title: 'WebHook 설정',
      otaLabel: 'OTA',
      endpoint: 'End point',
      secretToken: 'Secret token'
    },
    notificationsList: {
      title: '수동 알림',
      notification: '알림',
      resultCount: '검색 결과: {{count}}건',
      notificationTitle: '알림명',
      notificationContent: '알림 내용',
      sendTime: '전송 시간',
      sendStatus: '전송 상태',
      deleteConfirmTitle: '이 알림을 삭제하시겠습니까?',
      confirmDelete: '삭제',
      deleteWarning: '한 번 삭제하면 해당 알림은 복구할 수 없습니다',
      addNew: '신규 알림',
      send: '전송',
      confirmSend: '전송하기',
      sendConfirmTitle: '이 알림을 전송하시겠습니까?',
      sendSuccess: '알림이 전송되었습니다',
      sendFailed: '알림 전송에 실패했습니다',
      sendWarning: '전송 후에는 해당 알림을 취소할 수 없습니다',
      resend: '재전송',
      pin: '핀 고정',
      unpin: '핀 고정 해제',
      pinConfirmTitle: '이 알림 고정을 해제하시겠습니까?',
      unpinConfirmTitle:
        '이 작업은 취소할 수 없습니다. 계속하기 전에 내용을 확인해 주세요',
      confirmPin: '핀 고정',
      confirmUnpin: '해제',
      pinSuccess: '핀 고정 완료',
      pinFailed: '핀 고정 해제 실패',
      unpinSuccess: '핀 고정 해제 완료',
      unpinFailed: '핀 고정 해제 실패',
      failedEmailsTitle: '전송 실패 상세',
      failedEmailTo: '수신자',
      failedEmailReason: '실패 원인',
      failedEmailsLoadError: '정보 조회에 실패했습니다',
      noFailedEmails: '실패 데이터가 없습니다'
    },
    notificationDetail: {
      addTitle: '신규 알림',
      editTitle: '알림 수정',
      notificationTitle: '알림명',
      notificationContent: '알림 내용',
      relatedProducts: '관련 상품',
      productAll: '관련 없음',
      productSpecified: '특정 상품 지정',
      productIdsHint: '상품 ID 입력(반각 쉼표로 구분)',
      sendTiming: '전송 시간',
      sendNow: '즉시 전송',
      scheduled: '시간 설정 후 전송',
      scheduledTime: '예약 일시',
      editLanguages: '편집 언어',
      editLanguagesRequired: '편집 언어를 선택해 주세요',
      langTitle: '제목',
      langContent: '본문',
      targetScope: '대상 범위',
      targetAll: '전체',
      targetTypeEmail: '로그인 메일 주소로 전송',
      targetTypeRole: '권한을 선택하여 전송',
      targetEmailDomain: '대상 도메인',
      targetEmailDomainAdmin: 'Admin',
      targetEmailDomainOta: 'OTA',
      targetEmailDomainSupplier: 'SUP',
      toEmails: '수신자 이메일 주소',
      toEmailsHint: '이메일 주소 입력(반각 쉼표 「,」로 구분)',
      roleOta: 'OTA',
      roleSupplier: 'SUP',
      roleAdmin: '관리자',
      saveAsDraft: '임시 저장',
      send: '전송',
      savedAsDraft: '임시 저장 완료',
      saveAsDraftFailed: '임시 저장 실패',
      sendSuccess: '알림이 전송되었습니다',
      sendFailed: '알림 전송에 실패했습니다'
    }
  },
  const: {
    invoicePaymentType: {
      [InvoicePaymentType.PostBankTransfer]: '후불(은행 송금)',
      [InvoicePaymentType.PreLinkpay]: '사전 결제(온라인 결제)',
      [InvoicePaymentType.PostLinkpay]: '후불(LinkPay)',
      [InvoicePaymentType.PreCharge]: '사전 결제(은행 송금)'
    },
    invoicePaymentPeriod: {
      [InvoicePaymentPeriod.Monthly]: '월간',
      [InvoicePaymentPeriod.Weekly]: '주간',
      [InvoicePaymentPeriod.HalfMonthly]: '격주'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '입금 대기',
      [InvoiceStatus.InvoiceStatusConfirmed]: '입금 완료',
      [InvoiceStatus.InvoiceStatusPaid]: '입금 확인 중',
      [InvoiceStatus.InvoiceStatusCancelled]: '취소 완료'
    },
    walletOrderType: {
      [WalletOrderType.TypeBalance]: '잔액 충전',
      [WalletOrderType.TypeBuffer]: '버퍼 요금'
    },
    invoicePayStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '지급 준비중',
      [InvoiceStatus.InvoiceStatusConfirmed]: '결제 완료',
      [InvoiceStatus.InvoiceStatusPaid]: '입금 확인중',
      [InvoiceStatus.InvoiceStatusCancelled]: '취소 완료'
    },
    notificationStatus: {
      [NotificationStatus.NotificationStatusSent]: '전송 완료',
      [NotificationStatus.NotificationStatusTotalFailed]: '전송 실패',
      [NotificationStatus.NotificationStatusPartialFailed]: '일부 전송 실패',
      [NotificationStatus.NotificationStatusSending]: '전송 중',
      [NotificationStatus.NotificationStatusTempSaved]: '임시 저장',
      [NotificationStatus.NotificationStatusScheduled]: '전송 대기'
    },
    notificationLanguage: {
      [Language.English]: '영어',
      [Language.Japanese]: '일본어',
      [Language.Korean]: '한국어',
      [Language.SimplifiedChinese]: '중국어(간체)',
      [Language.TraditionalChinese]: '중국어(번체)'
    }
  }
};
